import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Typography, Stack } from '@mui/material';

export default function TextInputOptions({ data, updateValidationRules }) {
  const { t } = useTranslation(['procedures']);
  return (
    <>
      <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>
        {t('procedures:step_options.validation_rules')}
      </Typography>
      <Stack spacing={2}>
        <TextField
          fullWidth
          type="number"
          label={t('procedures:form_labels.text_input.min_length')}
          value={data.validation_rules?.min_length || 0}
          onChange={(e) => updateValidationRules({ min_length: parseInt(e.target.value) || 0 })}
        />
        <TextField
          fullWidth
          type="number"
          label={t('procedures:form_labels.text_input.max_length')}
          value={data.validation_rules?.max_length || 2000}
          onChange={(e) => updateValidationRules({ max_length: parseInt(e.target.value) || 2000 })}
        />
        {/* TODO: Add advanced toggle here */}
        <TextField
          fullWidth
          label={t('procedures:form_labels.text_input.regex_pattern')}
          placeholder={t('procedures:form_labels.text_input.regex_placeholder')}
          value={data.validation_rules?.pattern || ''}
          onChange={(e) => updateValidationRules({ pattern: e.target.value })}
        />
        <TextField
          fullWidth
          label={t('procedures:form_labels.text_input.pattern_error_message')}
          value={data.validation_rules?.pattern_message || ''}
          onChange={(e) => updateValidationRules({ pattern_message: e.target.value })}
        />
      </Stack>
    </>
  );
}
